import React from "react";
import './index.sass';
import { Input, Table, Button, message } from 'antd';
import Svg from "../../../../components/Svg";
import api from "../../../../utils/api";


export default class SkuEditor extends React.Component {
    constructor(props) {
        super(props)
        console.log(props)
        let skuParam = props.showSku

        console.log(skuParam)

        this.state = {
            skuParam,
            skuName: '',
            skuVal: []
        }
    }

    componentWillMount() {
        console.log(this.props)

        let oldItem = this.props.showSku.item;

        if (oldItem) {


            let resarr = oldItem['values']

            for (let i in resarr) {
                resarr[i] = {
                    val: resarr[i]
                }
            }

            oldItem['values'] = resarr;

            this.setState({
                skuName: oldItem['name'],
                skuVal: oldItem['values']
            })

        }

    }


    closeHandle = () => {
        this.props.colsePop({ show: false })
    }

    addSkuHandle = () => {//添加规格值
        let { skuVal } = this.state;

        //this.state.skuVal.push({ id: new Date().getTime(), val: '' })

        this.setState({
            skuVal: skuVal.concat([{ id: new Date().getTime(), val: '' }])
        })


        this.scrollToBottom(true)
    }

    delSkuHandle = (ctx, record, i) => {//删除规格值
        let { skuVal } = this.state;
        skuVal.splice(i, 1)
        console.log(ctx, record, i, skuVal)

        this.setState({
            skuVal: [...skuVal]
        })

    }

    scrollToBottom = () => {
        if (this.messagesEnd) {
            const scrollHeight = this.messagesEnd.scrollHeight;//里面div的实际高度  2000px
            const height = this.messagesEnd.clientHeight;  //网页可见高度  200px
            const maxScrollTop = scrollHeight - height;
            this.messagesEnd.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
            //如果实际高度大于可见高度，说明是有滚动条的，则直接把网页被卷去的高度设置为两个div的高度差，实际效果就是滚动到底部了。

            console.log('scrollHeight', scrollHeight)
        }
    }

    saveSku = async () => {
        let { skuVal, skuName } = this.state;

        let skuParam = this.props.showSku


        //console.log(skuParam)

        let values = []

        for (let i in skuVal) {
            if (!skuVal[i]) return
            values.push(skuVal[i]['val'])
        }

        let param = {
            specs: [
                {
                    name: skuName,
                    values
                }
            ]
        }

        let res

        if (skuParam.type === 'changeSku') {
            param['spec_id'] = skuParam.item.id

            res = await api('update-spec', param)
        } else {
            res = await api('add-specs', param)
        }


        if (res.code === 200) {
            message.success(res.message)

            this.closeHandle()

            this.props.updateSku(true)
        } else {
            message.error(res.message)
        }




        //console.log(skuVal, 'skuVal----------------', res, param)
    }


    render() {
        let { skuParam, skuVal, skuName } = this.state;


        const columns = [
            {
                title: '规格值',
                width: 160,
                key: 'id',
                render: (ctx, record, index) => {
                    console.log(ctx)
                    return (
                        <Input className='width150' value={ctx.val} placeholder='请输入规格值' onChange={(e) => {
                            skuVal[index]['val'] = e.target.value
                            this.setState({ skuVal })
                        }} />
                    )

                }
            },
            {
                title: '操作',
                render: (ctx, record, i) => {
                    return (
                        <div onClick={() => { this.delSkuHandle(ctx, record, i) }}>删除</div>
                    )
                }
            }
        ];

        return (
            <div className='skuEditor'>
                <div className='close'></div>


                <div className='popBox height500 oya'>
                    <p className='title'>
                        {
                            skuParam.type == 'changeSku' ? '编辑规格' : '添加规格'
                        }
                    </p>
                    <div className='popContent'>
                        <div className='flex line alignCenter'>
                            <label>规格名称：</label>
                            <Input onChange={(e) => { this.setState({ skuName: e.target.value }) }} value={skuName} className='width260' width={260} placeholder="请输入规格名称，例如：颜色，最多20字" />
                        </div>

                        <div className='flex line skuList'>
                            <label>规格值：</label>

                            <Table

                                scroll={{
                                    x: false,
                                    y: 250

                                }}

                                className='width260 height250'
                                pagination={false}
                                dataSource={skuVal}
                                columns={columns}
                                rowKey={record => record.id} />
                        </div>

                        <div onClick={() => { this.addSkuHandle() }} className='flex line addSku themeColor pointer'>
                            <Svg.addSku /> 添加规格值
                        </div>


                        <div className='flex line contrlBtn'>



                            <Button onClick={() => { this.saveSku() }} className='themeBtn mgr40'>{skuParam.type == 'changeSku' ? '修改' : '保存'}</Button>

                            <Button onClick={() => { this.closeHandle() }}>取消</Button>

                        </div>



                    </div>

                </div>

            </div>
        )
    }
}